/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from 'react';
import { Button, Modal } from 'antd';
import { IOrder } from '@/interfaces/order';
import { useReactToPrint } from 'react-to-print';
import { orderPrintCount } from '@/adapters/order';

import TM01 from './TM01';
import TM02 from './TM02';
import TM03 from './TM03';
import TM04 from './TM04';
import TM05 from './TM05';
import TM06 from './TM06';
import TM07 from './TM07';
import TM09 from './TM09';
import TM08 from './TM08';
import TM10 from './TM10';
import TM11 from './TM11';
import TM12 from './TM12';
import TM13 from './TM13';
import TM15 from './TM15';
import TM14 from './TM14';
import TM16 from './TM16';
import TM17 from './TM17';
import TM18 from './TM18';
import TM19 from './TM19';
import TM20 from './TM20';
import TM26 from './TM26';
import TM27 from './TM27';
import TM31 from './TM31';

interface IProps {
  open: boolean;
  handleCancel: () => void;
  afterPrint?: () => void;
  order: IOrder;
  tms: string[];
  qrCode?: string;
  driverId?: number;
}

const PrintModal = ({
  open,
  handleCancel,
  afterPrint,
  order,
  tms,
  driverId,
}: IProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `${order.code}`,
    onAfterPrint: async () => {
      await orderPrintCount(Number(order.id));
      afterPrint && afterPrint();
    },
  });

  return (
    <Modal
      title="พิมพ์เอกสาร"
      open={open}
      width={'1100px'}
      onOk={() => handleCancel}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ปิด
        </Button>,
        <Button type="primary" key="print" onClick={() => handlePrint()}>
          พิมพ์เอกสาร
        </Button>,
      ]}
    >
      <div className="flex flex-col overflow-y-auto bg-gray-200 p-2 max-h-[600px] font-ibm gap-5">
        <div ref={contentRef} className="flex flex-col">
          {tms.includes('TM01') && <TM01 data={order} />}

          {tms.includes('TM02') && <TM02 data={order} />}
          {tms.includes('TM03') && <TM03 data={order} />}
          {tms.includes('TM03') && <TM26 data={order} />}
          {tms.includes('TM04') && <TM04 data={order} />}
          {tms.includes('TM05') && <TM05 data={order} />}
          {tms.includes('TM05-2') && <TM05 data={order} />}
          {tms.includes('TM06') && <TM06 data={order} />}
          {tms.includes('TM07') && <TM07 data={order} />}
          {tms.includes('TM07-2') && <TM07 data={order} />}
          {tms.includes('TM08') && <TM08 data={order} />}
          {tms.includes('TM09') && <TM09 data={order} />}
          {tms.includes('TM10') && <TM10 data={order} />}
          {tms.includes('TM11') && <TM11 data={order} />}
          {tms.includes('TM11-2') && <TM11 data={order} />}
          {tms.includes('TM12') && <TM12 data={order} />}
          {tms.includes('TM13') && <TM13 data={order} />}
          {tms.includes('TM14') && <TM14 data={order} />}
          {tms.includes('TM15') && <TM15 data={order} />}
          {tms.includes('TM19') && <TM16 data={order} />}
          {tms.includes('TM20') && <TM17 data={order} />}
          {tms.includes('TM21') && <TM18 data={order} />}
          {tms.includes('TM22') && <TM19 data={order} />}
          {tms.includes('TM23') && <TM20 data={order} />}
          {tms.includes('TM16') && <TM26 data={order} />}
          {tms.includes('TM27') && <TM27 data={order} driverid={driverId} />}
          {tms.includes('TM31') && <TM31 data={order} />}
        </div>
      </div>
    </Modal>
  );
};

export default PrintModal;
